import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

interface AgentWidgetState {
  toggleRequest: number;
}

const initialState: AgentWidgetState = {
  toggleRequest: 0,
};

export const agentWidgetSlice = createSlice({
  name: 'agentWidget',
  initialState,
  reducers: {
    toggleAgentWidget: (state) => {
      state.toggleRequest += 1;
    },
  },
});

export const { toggleAgentWidget } = agentWidgetSlice.actions;

export const selectAgentWidgetToggle = (state: RootState) => {
  return state.agentWidget.toggleRequest;
};

export default agentWidgetSlice.reducer;
